import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/core/http/http.service';
import { GeneralService } from '../../services/general.service';
import { API } from 'src/app/configs';
import { HomeController } from 'src/app/modules/home/home.controller';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthState } from 'src/app/core/auth/auth-state';

@Component({
  selector: 'deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss']
})
export class DeepLinkComponent implements OnInit {

  loading = true;
  linkActive = null;
  linkInvalid = false;


  constructor(
    protected router:Router,
    private ActivatedRoute: ActivatedRoute,
    protected httpService: HttpService,
    protected gs: GeneralService,
    protected control : HomeController,
    protected as : AuthService
    ) { 
      
  }

  public ngOnInit(): void {

    let hash = this.ActivatedRoute.snapshot.paramMap.get('id');
    let ad = this.ActivatedRoute.snapshot.paramMap.get('ad');

    if(this.router.url.indexOf('/perfil/') > -1){
      let returnUrl = this.router.url;

      if(returnUrl?.indexOf('/perfil/') > -1 && hash && ad)
        returnUrl = '/realtor/view/'+ad;
      
      if(returnUrl?.indexOf('/perfil/') > -1 && hash && !ad)
        returnUrl = returnUrl.replace('/perfil/','/realtor/profile/');

      if(this.as.getActualAuthState().state == AuthState.SIGNED_IN){
        this.gs.returnUrl = returnUrl;
      } else {
        this.linkActive = 'Faça o login para acessar o perfil';
        this.router.navigate(['openModal','AuthenticatorComponent'], { queryParams: {json:JSON.stringify({ returnUrl: returnUrl})}});
      }

      this.loading = false;
      return;
    }

    if(this.router.url == '/signUpRealestate'){
      this.linkActive = 'Faça seu cadastro';
      this.router.navigate(['openModal','SignUpComponent'],{queryParams:{json:JSON.stringify({type:'realestate'})}});
      this.loading = false;
      return;
    }
   
    this.httpService.get<any>(API.user.general.signupinvited.setQueryParams({hash:hash}),{ })
    .then(result => {
      if(result?.return == 'error'){
        this.linkInvalid = result?.msg || true;
        return;
      } 
      this.linkActive = true;
      switch(result?.form){
        case 'login':
          this.linkActive = 'Faça o login para continuar';
          this.router.navigate(['openModal','AuthenticatorComponent'],{queryParams:{json:JSON.stringify({email:result.email})}});
        break;
        case 'signup':
            this.router.navigate(['openModal','SignUpComponent'],{queryParams:{json:JSON.stringify({email:result.email, perfil_id:result.perfil_id, hash:hash})}});
        break;
      }
    })
    .catch(error => {
      this.linkInvalid = true;
    })
    .finally(() => this.loading = false);
    

    this.control.init();
  }

}
